var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-box"},[_c('div',{staticClass:"famous-box"},[_c('img',{attrs:{"src":require("@/assets/image/chat.png"),"width":"300"}})])])
}]

export { render, staticRenderFns }